<div id="myModal" class="modal-content">
  <div class="modal-header-custom d-flex justify-content-between">
    <div>
      <div class="service-data">
        <span
          *ngIf="serviceData.nodeType === 'OPERATIVE_NODE'"
          class="service-name"
        >
          {{ serviceData.productName }}
        </span>
        <span
          *ngIf="serviceData.nodeType === 'SWEEPER_NODE'"
          class="service-name"
        >
          {{ "service_manager.modal.sweeper_car" | translate }}
        </span>
        <span
          *ngIf="serviceData.nodeType === 'TRANSPORT_NODE'"
          class="service-name"
        >
          {{ "service_manager.modal.public_transport" | translate }}
        </span>

        <span class="service-date text-muted">
          {{ routeDate | date : dateFormat : "" : currentLocale }}
        </span>
        <div
          class="display-contents"
          *ngIf="serviceData.nodeType !== 'TRANSPORT_NODE'"
        >
          <div class="service-hash">
            <span class="fw-semibold">Order hash:</span>
            {{ serviceData.orderHash }}
          </div>
          <div class="service-product">
            <!-- Matrícula -->
            <span class="fw-semibold">
              {{ "service_manager.modal.license_plate" | translate }}:
            </span>
            <span>{{ serviceData.licensePlate }}</span>
          </div>

          <!-- Tipo de vehículo -->
          <div>
            <span class="fw-semibold">
              {{ "service_manager.modal.vehicle_type" | translate }}:
            </span>
            {{ getChassisLabel(serviceData.vehicleChassis) }}
          </div>
        </div>
      </div>
      <!-- Badges para el estado de la orden -->
      <div *ngIf="serviceData?.orderStatus === 'INITIALIZED'">
        <tui-badge
          status="neutral"
          [value]="'service_manager.modal.initialized' | translate"
          class="tui-space_right-2 mt-2 tui-space_bottom-2 custom_initalized"
        ></tui-badge>
      </div>
      <div *ngIf="serviceData?.orderStatus === 'PENDING'">
        <tui-badge
          status="neutral"
          [value]="'service_manager.modal.pending' | translate"
          class="tui-space_right-2 mt-2 tui-space_bottom-2 custom_pending"
        ></tui-badge>
      </div>
      <div *ngIf="serviceData?.orderStatus === 'CONFIRMED'">
        <tui-badge
          status="success"
          [value]="'service_manager.modal.confirmed' | translate"
          class="tui-space_right-2 mt-2 tui-space_bottom-2 custom_confirmed"
        ></tui-badge>
      </div>
      <div *ngIf="serviceData?.orderStatus === 'PICKING_UP'">
        <tui-badge
          status="success"
          [value]="'service_manager.modal.picking_up' | translate"
          class="tui-space_right-2 mt-2 tui-space_bottom-2 custom_picking_up"
        ></tui-badge>
      </div>
      <div *ngIf="serviceData?.orderStatus === 'IN_PROGRESS'">
        <tui-badge
          status="success"
          [value]="'service_manager.modal.in_progress' | translate"
          class="tui-space_right-2 mt-2 tui-space_bottom-2 custom_picking_up"
        ></tui-badge>
      </div>
      <div *ngIf="serviceData?.orderStatus === 'DELIVERING'">
        <tui-badge
          status="success"
          [value]="'service_manager.modal.delivering' | translate"
          class="tui-space_right-2 mt-2 tui-space_bottom-2 custom_picking_up"
        ></tui-badge>
      </div>
      <div *ngIf="serviceData?.orderStatus === 'FINISHED'">
        <tui-badge
          status="success"
          [value]="'service_manager.modal.finished' | translate"
          class="tui-space_right-2 mt-2 tui-space_bottom-2 custom_finished"
        ></tui-badge>
      </div>
      <div *ngIf="serviceData?.orderStatus === 'FAILED'">
        <tui-badge
          status="error"
          [value]="'service_manager.modal.failed' | translate"
          class="tui-space_right-2 mt-2 tui-space_bottom-2"
        ></tui-badge>
      </div>
      <div *ngIf="serviceData?.orderStatus === 'CANCELLED_BY_CAFLER'">
        <tui-badge
          status="error"
          [value]="'service_manager.modal.cancelled_by_cafler' | translate"
          class="tui-space_right-2 mt-2 tui-space_bottom-2"
        ></tui-badge>
      </div>
      <div *ngIf="serviceData?.orderStatus === 'CANCELLED_BY_CLIENT'">
        <tui-badge
          status="error"
          [value]="'service_manager.modal.cancelled_by_client' | translate"
          class="tui-space_right-2 mt-2 tui-space_bottom-2"
        ></tui-badge>
      </div>
    </div>

    <button
      type="button"
      class="btn-close"
      (click)="bsModalRef?.hide()"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body-custom mt-3">
    <div
      *ngIf="serviceData.nodeType !== 'TRANSPORT_NODE'"
      class="client-data d-flex align-items-center mb-1"
    >
      <tui-svg src="tuiIconUser"></tui-svg>
      <div *ngIf="serviceData.nodeType === 'OPERATIVE_NODE'">
        <span class="fw-bold"
          >{{ "service_manager.modal.client" | translate }}:
        </span>
        <span>{{ serviceData.clientName }} </span>
      </div>
      <div *ngIf="serviceData.nodeType === 'SWEEPER_NODE'">
        <span class="fw-bold"
          >{{ "service_manager.modal.driver" | translate }}:
        </span>
        <span>{{ serviceData.driverName }} </span>
      </div>
    </div>
    <div class="client-data d-flex align-items-center mb-1">
      <tui-svg src="tuiIconClock"></tui-svg>
      <div>
        <span class="fw-bold"
          >{{ "service_manager.modal.pickup_time" | translate }}:
        </span>
        <span>
          {{ getFormattedTime(serviceData.serviceStartDate.seconds) }}
        </span>
      </div>
    </div>
    <div
      *ngIf="
        serviceData.nodeType === 'SWEEPER_NODE' ||
        serviceData.nodeType === 'TRANSPORT_NODE'
      "
      class="client-data d-flex align-items-center mb-1"
    >
      <tui-svg src="tuiIconClock"></tui-svg>
      <div>
        <span class="fw-bold"
          >{{
            "service_manager.modal.estimated_arrival_time" | translate
          }}:</span
        >
        <span>
          {{ getFormattedTime(serviceData.serviceEndDate.seconds) }}
        </span>
      </div>
    </div>
    <div class="client-data d-flex align-items-center mb-1">
      <tui-svg src="tuiIconMapPin"></tui-svg>
      <div>
        <span class="fw-bold"
          >{{ "service_manager.modal.pickup_point" | translate }}:&nbsp;</span
        >
        <span> {{ serviceData.serviceStartAddress }} </span>
      </div>
    </div>

    <div
      class="client-data d-flex align-items-center mb-1"
      *ngIf="serviceData?.providerUbication?.length"
    >
      <tui-svg src="tuiIconMapPin"></tui-svg>
      <div *ngFor="let ub of serviceData.providerUbication; let i = index">
        <span class="fw-bold">
          {{ "service_manager.modal.provider_point" | translate
          }}<ng-container *ngIf="serviceData.providerUbication.length > 1">
            #{{ i + 1 }} </ng-container
          >: &nbsp;</span
        >
        <span>{{ ub.providerAddress }}</span>
      </div>
    </div>

    <div class="client-data d-flex align-items-center mb-1">
      <tui-svg src="tuiIconMapPin"></tui-svg>
      <div>
        <span class="fw-bold"
          >{{ "service_manager.modal.dropoff_point" | translate }}:&nbsp;</span
        >
        <span>
          {{ serviceData.serviceFinishAddress }}
        </span>
      </div>
    </div>
  </div>

  <div
    *ngIf="durationTotal !== null && durationTotal !== undefined"
    class="durations-container"
  >
    <!-- ——— Driver Mode ——— -->
    <ng-container *ngIf="mapType === 'caflerDrivingModeMap'; else transitMode">
      <div class="duration-row single">
        <strong>{{ "service_manager.modal.total_time" | translate }}</strong>
        <span>{{ human(durationTotal) }}</span>
      </div>
    </ng-container>

    <!-- ——— Public Transport Mode ——— -->
    <ng-template #transitMode>
      <div class="duration-row three-cols">
        <div class="duration-col">
          <strong>{{ "service_manager.modal.total_time" | translate }}</strong>
          <span>{{ human(durationTotal) }}</span>
        </div>

        <div class="duration-col">
          <strong>{{
            "service_manager.modal.transit_time" | translate
          }}</strong>
          <span>{{ human(durationTransit) }}</span>
        </div>

        <div class="duration-col">
          <strong>{{
            "service_manager.modal.walking_time" | translate
          }}</strong>
          <span>{{ human(durationWalking) }}</span>
        </div>
      </div>
    </ng-template>
  </div>

  <!-- ORIGINAL GOOGLE MAPS -->
  <div
    #littleGmapCompleteContainer
    id="littleGmapComplete"
    class="map_modal"
    *ngIf="mapType === 'completePublicTransportModeMap'"
  ></div>

  <!-- GOOGLE MAP WITH CAFLER STYLE-->
  <div
    #littleGmapContainer
    id="map"
    class="map_modal"
    *ngIf="mapType === 'caflerDrivingModeMap'"
  ></div>

  <div
    class="warnings-container mt-2"
    *ngIf="routeWarningKey as warn"
    role="alert"
  >
    <tui-svg src="tuiIconAlertCircle" class="warn-icon"></tui-svg>
    <span class="warn-text">{{ warn | translate }}</span>
  </div>

  <div class="flex-container">
    <!-- Botón → pasar de transporte público a coche -->
    <button
      *ngIf="mapType === mapKind.Public"
      (click)="onChangeMapType(mapKind.Driver)"
      class="blue-transparent-btn"
    >
      {{ "service_manager.modal.show_car_route" | translate }}
    </button>

    <!-- Botón → pasar de coche a transporte público -->
    <button
      *ngIf="mapType === mapKind.Driver"
      (click)="onChangeMapType(mapKind.Public)"
      class="blue-transparent-btn"
    >
      {{ "service_manager.modal.show_public_route" | translate }}
    </button>
  </div>

  <div class="open-gmaps-container">
    <button
      class="blue-transparent-btn"
      type="button"
      (click)="openInGoogleMaps()"
    >
      {{ "service_manager.modal.open_in_google_maps" | translate }}
    </button>
  </div>

  <div
    *ngIf="
      serviceData &&
      serviceData.driverId &&
      serviceData.nodeType !== 'TRANSPORT_NODE'
    "
    class="mt-3 lock-driver-container"
  >
    <!-- Node Lock Toggle with Loader -->
    <div
      class="d-flex align-items-center gap-2 mt-2"
      [attr.aria-busy]="nodeStatusLoading"
    >
      <label class="d-flex align-items-center gap-2 mb-0">
        <tui-toggle
          [ngModel]="isNodeLockedForDriverAssignation"
          (ngModelChange)="onToggle($event)"
          size="l"
        >
        </tui-toggle>
        <span class="fw-semibold">
          {{ "service_manager.modal.node_locked" | translate }}
        </span>
      </label>

      <!-- Inline loader while HTTP request is in flight -->
      <tui-loader *ngIf="nodeStatusLoading" size="s" class="ms-2"></tui-loader>
    </div>

    <!-- Explanatory helper text -->
    <p class="text-secondary small mt-1">
      {{ "service_manager.modal.node_locked_hint" | translate }}
    </p>
  </div>
  <div
    *ngIf="serviceData.nodeType !== 'TRANSPORT_NODE'"
    class="modal-footer-custom"
  >
    <button (click)="viewDetail()" class="export-button-menu mb-2 mt-3">
      {{ "service_manager.modal.view_service_details" | translate }}
    </button>
  </div>
</div>
